/**
=========================================================
* Clifford Inu
=========================================================
*/
import React from 'react'

import PropTypes from 'prop-types'

// @mui material components
import {
    Grid,
    Typography,
    CircularProgress,
    Box,
    Breadcrumbs,
    Card,
    Divider,
    Button,
} from '@material-ui/core'

// Material Dashboard 2 React example components
// import TimelineItem from "examples/Timeline/TimelineItem";
// import DefaultInfoCard from 'examples/Cards/InfoCards/DefaultInfoCardWoImg'
// import ImageCard from 'examples/Cards/InfoCards/ImageCard'

// import { openSeaCollections, getOpenSeaCollecionsAssetsNumber } from "../../../nft/utils";

// const deployerWallet = "0x81ed317154e4c6e829b0358f59c5578719e95ccb";
const formatter = new Intl.NumberFormat('en-US', {})
var formatterUS = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
})
function NFTsOverview({ nftDataTable, assetsNumber, nftPortfolio }) {
    return (
        <Card style={{ height: '300px', overflow: 'auto' }}>
            <Box pt={3} px={3}>
                <Typography variant="h4" fontWeight="medium">
                    NFTS
                </Typography>
            </Box>

            <Box p={2}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={4} lg={4}>
                        <Box mb={1.5}>
                            <Card
                                style={{
                                    border: '1px solid',
                                    borderImageSlice: 1,
                                    borderImageSource:
                                        'linear-gradient(270deg, rgba(223,74,83,1) 0%, rgba(73,58,242,1) 100%)',
                                }}
                            >
                                <Box
                                    pb={2}
                                    px={2}
                                    textAlign="center"
                                    lineHeight={1.25}
                                >
                                    <Typography
                                        variant="h6"
                                        fontWeight="medium"
                                        textTransform="capitalize"
                                    >
                                        Collections
                                    </Typography>

                                    <Typography
                                        variant="caption"
                                        color="text"
                                        fontWeight="regular"
                                    >
                                        {formatter.format(nftDataTable.length)}
                                    </Typography>
                                </Box>
                            </Card>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                        <Box mb={1.5}>
                            <Card
                                style={{
                                    border: '1px solid',
                                    borderImageSlice: 1,
                                    borderImageSource:
                                        'linear-gradient(270deg, rgba(223,74,83,1) 0%, rgba(73,58,242,1) 100%)',
                                }}
                            >
                                <Box
                                    pb={2}
                                    px={2}
                                    textAlign="center"
                                    lineHeight={1.25}
                                >
                                    <Typography
                                        variant="h6"
                                        fontWeight="medium"
                                        textTransform="capitalize"
                                    >
                                        NFTS
                                    </Typography>

                                    <Typography
                                        variant="caption"
                                        color="text"
                                        fontWeight="regular"
                                    >
                                        {formatter.format(assetsNumber)}
                                    </Typography>
                                </Box>
                            </Card>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                        <Box mb={1.5}>
                            <Card
                                style={{
                                    border: '1px solid',
                                    borderImageSlice: 1,
                                    borderImageSource:
                                        'linear-gradient(270deg, rgba(223,74,83,1) 0%, rgba(73,58,242,1) 100%)',
                                }}
                            >
                                <Box
                                    pb={2}
                                    px={2}
                                    textAlign="center"
                                    lineHeight={1.25}
                                >
                                    <Typography
                                        variant="h6"
                                        fontWeight="medium"
                                        textTransform="capitalize"
                                    >
                                        NFTS Value
                                    </Typography>

                                    <Typography
                                        variant="caption"
                                        color="text"
                                        fontWeight="regular"
                                    >
                                        {formatterUS.format(nftPortfolio)}
                                    </Typography>
                                </Box>
                            </Card>
                        </Box>
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    {nftDataTable
                        .filter((item, idx) => idx < 24)
                        .map((item, idx) => (
                            /* eslint-disable  */
                            <Grid item xs={2} md={2} lg={1} key={idx}>
                                <Box width="3rem" height="3rem">
                                    <Card>
                                        <Box
                                            // key={color}
                                            src={item.permalink}
                                            component="a"
                                            href={item.permalink}
                                            target="_blank"
                                            rel="noreferrer"
                                            // fontSize={size.lg}
                                            // color={socialMediaColors[color].main}
                                            pr={0}
                                            pl={0}
                                            lineHeight={0}
                                        >
                                            <Box
                                                component="img"
                                                src={item.imageUrl}
                                                alt="NFTs"
                                                borderRadius="lg"
                                                shadow="md"
                                                width="100%"
                                                height="100%"
                                                position="relative"
                                                zIndex={1}
                                            />
                                        </Box>
                                    </Card>

                                    {/*    <ImageCard
                                        color="success"
                                        // title="NFTS"
                                        // description={<div>{formatter.format(nftAssetsNumber)}</div>}
                                        img={item.imageUrl}
                                        link={item.permalink}
                                        icon="notifications"
                                    /> */}
                                </Box>
                            </Grid>
                        ))}
                </Grid>

                {/*   <MDBox p={2} mt="auto">
                    <MDButton
                        component="a"
                        href="/nft"
                        rel="noreferrer"
                        variant="gradient"
                        color="success"
                        fullWidth
                    >
                        OPEN NFTS
                    </MDButton>
                </MDBox> */}
            </Box>
        </Card>
    )
}

// Setting default values for the props of DefaultInfoCard
NFTsOverview.defaultProps = { nftDataTable: [], assetsNumber: 0 }

// Typechecking props for the DefaultInfoCard
NFTsOverview.propTypes = {
    nftDataTable: PropTypes.arrayOf(PropTypes.object),
    assetsNumber: PropTypes.number,
}

export default NFTsOverview
